import { RelatoriosProvider } from './RelatoriosContext';
import RelatoriosContent from './RelatoriosContent';

export default function RelatoriosPage() {
  return (
    <RelatoriosProvider>
      <RelatoriosContent />
    </RelatoriosProvider>
  );
}
